import { render } from "./MalaTags.vue?vue&type=template&id=386fe1e7&scoped=true"
import script from "./MalaTags.vue?vue&type=script&lang=js"
export * from "./MalaTags.vue?vue&type=script&lang=js"

import "./MalaTags.vue?vue&type=style&index=0&id=386fe1e7&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-386fe1e7"]])

export default __exports__